import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '@/components/usePageTitle';
import { AuditLog } from '@/features/ops/AuditLog';

export const Route = createFileRoute('/_staff/staff/audit')({ component: AuditPage });

function AuditPage() {
  const { t } = useTranslation('ops');
  usePageTitle(t('audit.title'));
  return <AuditLog />;
}
